import {ReactElement} from "react";
import {MarginItem, MenuFormat} from "../MenuDocumentModel";
import {EditorItem} from "../editorUtils";

export interface MarginPreviewItemProps {
    format: MenuFormat
    margin: EditorItem<MarginItem>
    showBorders: boolean
}

export function MarginPreviewItem(props: MarginPreviewItemProps): ReactElement {
    return (
        <div className={props.showBorders ? "border border-dotted border-gray-2" : "border border-white"}
             style={{height: `${props.margin.menuItem.height}mm`}} />
    );
}
